import PropTypes from 'prop-types'
import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"

const DeleteModal = ({ show, onClick, onCloseClick, data }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
                <i
                  className="mdi mdi-alert-circle-outline"
                  style={{ fontSize: "5em", color: "red" }}
                />
              <h2>Are you sure ?</h2>
              {data?.type == 'Assign' &&
                <h4>{`You want to Assign ${data?.lead?.name} to ${data?.userName}!`}</h4>
              }
              {data?.type == 'Archive' &&
                <h4>{`You want to Archive ${data?.lead?.name}!`}</h4>
              }
              {data?.type == 'Unarchive' &&
                <h4>{`You want to Unarchive ${data?.lead?.name}!`}</h4>
              }
              {data?.type == 'Status' &&
                <h4>{`You want to Change ${data?.lead?.name} Status as ${data?.status}!`}</h4>
              }
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-success btn-lg me-2"
                onClick={onClick}
              >
                {data?.type!="Status" ? `Yes, ${data?.type} it!` : `Yes, ${data?.status} it!`}
              </button>
              <button
                type="button"
                className="btn btn-danger btn-lg me-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default DeleteModal
